module.exports = __webpack_public_path__ + "static-portal/img/22.3a6a71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/22.jpg
// module id = kYZr
// module chunks = 4